import { render, staticRenderFns } from "./areaTree.vue?vue&type=template&id=f05f0352&scoped=true"
import script from "./areaTree.vue?vue&type=script&lang=js"
export * from "./areaTree.vue?vue&type=script&lang=js"
import style0 from "./areaTree.vue?vue&type=style&index=0&id=f05f0352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05f0352",
  null
  
)

export default component.exports